import { useState, useEffect } from "react";

export function useMediaQuery(query: string): boolean {
  // Read synchronously on first render (client-only SPA), so width-dependent
  // layout (e.g. the Header's desktop top strip) doesn't appear a frame late.
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}
